import o from"react";import{CookiesManager as e}from"./cookiesManager.js";const r=o.createContext(new e);export{r as CookiesContext};
//# sourceMappingURL=cookiesContext.js.map
